export function addCurrent(rulesattendance) {
    return {
        type: 'ADD_CURRENT',
        rulesattendance,
    }
}
